import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Container from "@mui/material/Container";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import {
  DataGridPro,
  GridActionsCellItem,
  GridToolbarFilterButton,
  GridPaginationModel,
  GridColDef,
  GridToolbarContainer,
  GridToolbarExport,
  getGridStringOperators,
  GridLogicOperator,
} from "@mui/x-data-grid-pro";

import { DataGrid } from "../../util/DataGrid";
import { ServiceName } from "../../../constants";
import { getApiCall, postApiCall } from "../../../services/apiHelper";
import { AppraisalReviewServiceURL, TaskmgmtServiceURL } from "../../../config/config";
import { useEffect, useState } from "react";
import { TodoModel, lazyloadingFilters } from "../../util/All_interfaces";
import { GridFilterModel } from "@mui/x-data-grid";
import { Button } from "@mui/material";
import { CurrentUser } from "../../../redux/slices/currentUserSlice";
import { useAppSelector } from "../../../redux/hooks";


const TodoDashboard = () => {
  const navigate = useNavigate();
  const [value, setValue] = React.useState("1");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const [fetchedTodo, setFetchedTodo] = useState<TodoModel[]>([]);
  const [pageSize, setPageSize] = useState<number>(10);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: pageSize,
  });
  const [filterModel, setFilterModel] = React.useState<GridFilterModel>({
    items: [],
    logicOperator:GridLogicOperator.And
  });
  const currentUserData: CurrentUser = useAppSelector(
    (state) => state.currentUser.data
  );
  const [filterRoles, setFilterRoles] = React.useState<lazyloadingFilters[]>([]);
  const [rowCount, setRowCount] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchData = async (paginationModel: GridPaginationModel, filterModel: GridFilterModel) => {
    setLoading(true);
    await GetRoles(paginationModel, filterModel).then(
      (data: any) => {
        console.log(data.result);

        setFetchedTodo(data?.result?.todoList || []);
        setRowCount(data.result.rowCount);
      }
    ).catch((e) => {
      console.log(e);

    }).finally(() => { setLoading(false) });
  };

  const GetRoles = async (paginationModel: GridPaginationModel, filterModel: GridFilterModel) => {
    var rolesArr: any[] = [];
    filterModel?.items?.forEach((rolesFilter: any) => {
      if (rolesFilter?.value != undefined) {
        rolesArr.push( {
          identity: rolesFilter?.field,
          matchMode: rolesFilter?.operator,
          value: rolesFilter?.value,
        });
      }
    });

    var url = AppraisalReviewServiceURL + "/appraisals/GetTodoList?emailAddress";
    var payload = {
      filters: rolesArr,
      first: paginationModel.pageSize * paginationModel.page,
      filterConditionalOperator: filterModel.logicOperator,
      globalFilter: null,
      rows: paginationModel.pageSize,
      sortOrder: 1,
      emailId : "Ser_NRETest4@qicaait.org" //currentUserData.email?.toLowerCase(),
    };
    if(payload.filters.length == 0){
      payload = {...payload,filterConditionalOperator:GridLogicOperator.And}
    }
    const response = postApiCall(url, payload, "AppraisalReviewService").then((data: any) => data);
    return response;
  };

  useEffect(() => {
    fetchData(paginationModel, filterModel);
  }, [paginationModel, filterModel]);

  const columns: GridColDef[] = [
    {
      field: "action",
      headerName: "Actions",
      sortable: false,
      filterable: false,
      disableExport: true,
      renderCell: (cellValues) => {
        const onEditClick = (e: any) => {
          e.stopPropagation();
          navigate("/main/" + "edit/" + cellValues.id);
        };

        const onViewClick = (e: any) => {
          e.stopPropagation();
          navigate("/main/" + "view/" + cellValues.id);
        };
        return (
          <>
            <GridActionsCellItem
              sx={{
                color: "#253746",
              }}
              icon={<VisibilityIcon />}
              label="View"
              onClick={(event) => {
                onViewClick(event);
              }}
            />
            <GridActionsCellItem
              sx={{
                color: "#253746",
              }}
              icon={<EditIcon />}
              label="Edit"
              onClick={(event) => {
                onEditClick(event);
              }}
            />
          </>
        );
      },
      flex: 1,
    },
    { field: "status", headerName: "Review Status", flex: 1,
    filterOperators: getGridStringOperators().filter(
      (operator) => operator.value === "contains"
    )  },
    { field: "investmentId", headerName: "Investment Id", flex: 1,
    filterOperators: getGridStringOperators().filter(
      (operator) => operator.value === "contains"
    )  },
    { field: "investmentName", headerName: "Investment Name", flex: 1,
    filterOperators: getGridStringOperators().filter(
      (operator) => operator.value === "contains"
    )  },
    { field: "investmentType", headerName: "Investment Type", flex: 1,
    filterOperators: getGridStringOperators().filter(
      (operator) => operator.value === "contains"
    )  },
    { field: "fund", headerName: "Fund", flex: 1,
    filterOperators: getGridStringOperators().filter(
      (operator) => operator.value === "contains"
    )  },
    { field: "valueDate", headerName: "Appraisal Date", flex: 1,
    filterOperators: getGridStringOperators().filter(
      (operator) => operator.value === "contains"
    )  },
    { field: "appraisalType", headerName: "Appraisal Type", flex: 1,
    filterOperators: getGridStringOperators().filter(
      (operator) => operator.value === "contains"
    )  },
  ];

  const handelPaginationModel = (e: GridPaginationModel) => {
    setPaginationModel(e);
    fetchData(e, filterModel);
  };

  const handelFilterModelChange = (model: any) => {
    setFilterModel(model);
    fetchData(paginationModel, model);
  };

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer>
       
      </GridToolbarContainer>
    );
  };
  return (
    <Container maxWidth={false} className="dashboard-wrap">
      <Box sx={{ width: "100%", typography: "body1" }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={handleChange}
              aria-label="investment Tab"
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="All Items" value="1"  sx={{textTransform:'capitalize'}}/>
            </TabList>
          </Box>
          <TabPanel value="1">
              <DataGrid
                getRowId={(rows: any) => rows.appraisalId}
                rows={fetchedTodo || []}
                rowCount={rowCount}
                columns={columns}
                paginationModel={paginationModel}
                PaginationModelChange={handelPaginationModel}
                filterModel={filterModel}
                loading={loading}
                filterModelChange={(model: GridFilterModel) => handelFilterModelChange(model)}
                customToolbar={CustomToolbar}
                columnHeaderHeight={48}
                headerFilters
                headerFilterHeight={48}
                paginationMode="server"
                filterMode="server"
                sortingMode="server"
                pageSizeOptions={[25, 50, 100]}
                rowHeight={40}
                pagination
              />
          </TabPanel>
        </TabContext>
      </Box>
    </Container>
  );
};

export default TodoDashboard;

